import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} - Gestta`;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
